import React from 'react';
import Announce from '../components/Announce';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Newsletter from '../components/Newsletter';
import Products from '../components/Products';

const CategoryPage = ({ onChangePage }) => {
  return (
    <div>
      <Announce />
      <Navbar onChangePage={onChangePage} />
      <div className="flex flex-col p-5">
        <div className="text-3xl">Men's Cloth</div>
        <div className="flex justify-between items-center mt-3">
          <div className="flex mobile:flex-col">
            <p>Filter by</p>
            <select className="ml-3 border-2 border-silver">
              <option selected disabled>
                Size
              </option>
              <option value="Small">Small</option>
              <option value="Medium">Medium</option>
              <option value="Large">Large</option>
            </select>
            <select className="ml-3 border-2 border-silver mobile:mt-3">
              <option selected disabled>
                Color
              </option>
              <option value="Red">Red</option>
              <option value="Yelllow">Yellow</option>
              <option value="Blue">Blue</option>
            </select>
          </div>
          <div className="flex">
            <p>Sort by</p>
            <select className="ml-3 border-2 border-silver">
              <option>Newset (first)</option>
              <option>Oldest (first)</option>
              <option>Price (Acc)</option>
              <option>Price (Desc)</option>
            </select>
          </div>
        </div>
      </div>
      <Products />
      <Newsletter />
      <Footer />
    </div>
  );
};

export default CategoryPage;
